import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { map, mergeMap, withLatestFrom } from 'rxjs/operators';

import { LOAD_BRAND_DATA_SUCCESS } from '@amfam/shared/utility/brand/lib/+state/brand.actions';
import { selectPartnerId } from '@amfam/shared/utility/brand/lib/+state/brand.selectors';
import { ContentService } from '@amfam/shared/utility/shared-services/lib/content/content.service';

import {
  loadSystemBannerFail,
  loadSystemBannerSuccess
} from '../app-bootstrap/app-bootstrap.actions';

/**
 * Once Brand Data is available, get the Outage Banner content while sending PartnerId as a parameter. The Outage Banner
 * content is dynamic based on partnerId sent.
 */

export const start = createEffect(
  (actions$ = inject(Actions), contentService = inject(ContentService), store = inject(Store)) => {
    return actions$.pipe(
      ofType(LOAD_BRAND_DATA_SUCCESS),
      withLatestFrom(store.select(selectPartnerId)),
      mergeMap(([_action, partnerId]) => {
        const contentPath = 'OutageBanner?partnerId=' + partnerId;
        return contentService.getContent(contentPath).pipe(
          map(contentResponse => {
            if (contentResponse.richContent !== '') {
              return loadSystemBannerSuccess(contentResponse);
            } else {
              return loadSystemBannerFail(contentResponse);
            }
          })
        );
      })
    );
  },
  { functional: true }
);
